import SellOutlinedIcon from "@mui/icons-material/SellOutlined"
import { Divider, Stack, Typography } from "@mui/material"
import { ReactElement } from "react"

import { IReleaseNote } from "./types"
import AppChip from "../../components/dataDisplay/chips/appChip"
import { AppCardHeader } from "../../components/surfaces/appCard"
import DisplayIf from "../../components/wrappers/displayIf"
import { useGetUserData } from "../../hooks/useGetUserData"
import ExtendedTextBuilder from "../privacyPage/extendedTextBuilder"

interface IReleaseNoteProps {
    release: IReleaseNote
}

const ReleaseNote = ({ release }: IReleaseNoteProps): ReactElement => {
    const {
        isInstaller,
        isManuApproved,
        isDnoApproved,
        isDemandAssessor,
        isGenAssessor,
        isEnaSysAdmin,
    } = useGetUserData()

    const isReleased =
        release.status === "PAST" || release.status === "RELEASED"

    const chipColor = isReleased ? "success" : "primary"

    const chipLabel = isReleased ? "Released" : "Upcoming"
    return (
        <Stack>
            <AppCardHeader
                avatar={<SellOutlinedIcon fontSize="large" />}
                title={
                    <Stack
                        direction="row"
                        spacing={3}
                        alignItems="center"
                        paddingY={1}
                    >
                        <Typography variant="h5" fontWeight={500}>
                            {release.title}
                        </Typography>
                        <AppChip
                            label={chipLabel}
                            variant="filled"
                            color={chipColor}
                        />
                    </Stack>
                }
                subheader={`${release.date}  \u2022  ${release.releaseType} Release`}
            />
            <Divider sx={{ mt: 1 }} />
            <ExtendedTextBuilder body={release.notesBodyAllUsers} />

            <DisplayIf
                condition={isInstaller || isEnaSysAdmin || isDnoApproved}
            >
                <ExtendedTextBuilder body={release.notesBodyInstaller} />
            </DisplayIf>

            <DisplayIf condition={isEnaSysAdmin || isDnoApproved}>
                <ExtendedTextBuilder body={release.notesBodyDno} />
            </DisplayIf>

            <DisplayIf
                condition={isManuApproved || isEnaSysAdmin || isDnoApproved}
            >
                <ExtendedTextBuilder body={release.notesBodyManu} />
            </DisplayIf>

            <DisplayIf
                condition={isDemandAssessor || isEnaSysAdmin || isDnoApproved}
            >
                <ExtendedTextBuilder body={release.notesBodyDbAssessorDemand} />
            </DisplayIf>

            <DisplayIf
                condition={isGenAssessor || isEnaSysAdmin || isDnoApproved}
            >
                <ExtendedTextBuilder body={release.notesBodyDbAssessorGen} />
            </DisplayIf>
        </Stack>
    )
}

export default ReleaseNote
